import { DOCUMENT } from "@angular/common";
import { APP_INITIALIZER, Provider } from "@angular/core";
import { LinkInterceptor } from "./link-interceptor";

function startLinkInterception(interceptor: LinkInterceptor, doc: Document): () => void {
  return () => interceptor.start(doc);
}

/** Forwards the link activations of the app to the host page, from the app start. */
export function provideLinkHandling(): Provider[] {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: startLinkInterception,
      multi: true,
      deps: [LinkInterceptor, DOCUMENT],
    },
  ];
}
